export default __webpack_public_path__ + "static/media/refresh.3db68197.svg";